import i18n from 'services/base/i18n';

export default {
  // Text for the link to the manage pangolin page
  managePangolins: () => i18n.pgettext('Pages|More', 'Manage Pangolins'),

  // Text for the link to the add pangolin page
  addPangolin: () => i18n.pgettext('Pages|More', 'Add a Pangolin'),

  // Text for the link to the settings page
  settings: () => i18n.pgettext('Pages|More', 'Settings'),

  // Button that opens a web browser to the user manual
  userManual: () => i18n.pgettext('Pages|More', 'User Manual'),

  // Button that opens a web browser to our update history page
  updateHistory: () => i18n.pgettext('Pages|More', 'Update History'),

  // Button that opens a web browser to our news page
  news: () => i18n.pgettext('Pages|More', 'News'),

  // Button that opens a web browser to our support page
  support: () => i18n.pgettext('Pages|More', 'Support'),

  // Button to log out of the application
  signOut: () => i18n.pgettext('Pages|More', 'Sign Out'),
};
